import { render, staticRenderFns } from "./business-personal-data.vue?vue&type=template&id=7810140a&"
import script from "./business-personal-data.vue?vue&type=script&lang=js&"
export * from "./business-personal-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports